"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const config_1 = require("config");
const merchant_portal_components_1 = require("merchant-portal-components");
const showAdjustButton_1 = require("../_utils/showAdjustButton");
const ColumnActions = ({ row }) => {
    const rowData = row.original;
    const isInstallment = rowData.transactionType === config_1.TRANSACTION_TYPE.LOAN;
    const buttonLink = isInstallment
        ? `${config_1.ACCOUNT_DETAIL_URL}${rowData.alphaeonAccountNumber}${config_1.LOAN_ADJUSTMENT_URL}`
        : `${config_1.VOID_SALE_URL}${rowData.alphaeonAccountNumber}`;
    return ((0, jsx_runtime_1.jsxs)("span", { className: "actions", children: [(0, jsx_runtime_1.jsx)(merchant_portal_components_1.AuthorizedLink, { to: `${config_1.ACCOUNT_DETAIL_URL}${rowData.alphaeonAccountNumber}`, requiredPermission: config_1.PERMISSION.ACCOUNT_LOOKUP, children: "VIEW" }), (0, showAdjustButton_1.showAdjustButton)(rowData) && ((0, jsx_runtime_1.jsx)(merchant_portal_components_1.AuthorizedLink, { to: {
                    pathname: `${buttonLink}`,
                    state: {
                        alphaeonAccountNumber: rowData.alphaeonAccountNumber,
                        creditLimit: rowData.amount,
                        id: rowData.alphaeonAccountNumber,
                        name: rowData?.name,
                        transaction: {
                            amount: rowData.amount,
                            planName: rowData.planName,
                            locationName: rowData.locationName,
                            transactionId: rowData.id,
                            createdAt: rowData.createdAt,
                            transactionType: rowData.transactionType,
                            status: rowData.status,
                            voidedAt: rowData.voidedAt,
                        },
                    },
                }, requiredPermission: config_1.PERMISSION.ACCOUNT_LOOKUP, children: "ADJUST" }))] }));
};
exports.default = ColumnActions;
